<template>
  <div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>
              <p><strong>参数名</strong></p>
            </th>
            <th>
              <p><strong>值</strong></p>
            </th>
            <th>
              <p><strong>规则说明</strong></p>
            </th>
            <th>
              <p><strong>是否必填</strong></p>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>
              <p>key</p>
            </td>
            <td>
              <el-input v-model="params.key"
                        size="small"
                        placeholder="请求服务权限标识" />
            </td>
            <td>
              <p>
                请求服务权限标识
              </p>
            </td>
            <td>
              <p>是</p>
            </td>
          </tr> -->
          <tr>
            <td>
              <p>polygon</p>
            </td>
            <td>
              <el-input v-model="params.polygon"
                        size="small"
                        placeholder="经纬度坐标对" />
            </td>
            <td>
              <p>经纬度坐标对</p>
            </td>
            <td>
              <p>是</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>keywords</p>
            </td>
            <td>
              <el-input v-model="params.keywords"
                        size="small"
                        placeholder="查询关键字" />
            </td>
            <td>
              <p>
                查询关键字
              </p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>location</p>
            </td>
            <td>
              <el-input v-model="params.location"
                        size="small"
                        placeholder="当前位置坐标" />
            </td>
            <td>
              <p>
                当前位置坐标
              </p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>page</p>
            </td>
            <td>
              <el-input v-model="params.page"
                        size="small"
                        placeholder="当前页数"></el-input>
            </td>
            <td>
              <p></p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>pagesize</p>
            </td>
            <td>
              <el-input v-model="params.pagesize"
                        size="small"
                        placeholder="每页记录数据" />
            </td>
            <td>
              <p>建议不超过20，若超过20使用默认值</p>
            </td>
            <td>
              <p>否</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="margin-top: 12px">
      <button class="black-btn"
              @click="run">运行</button>
    </div>
    <div v-if="res"
         class="result-container">
      <div class="header">
        <div class="button-container"
             v-if="depth === 1"
             style="margin-right:18px"
             @click="expand">
          <img src="../assets/icon-expand.svg"
               alt="">
          <el-button type="text"
                     size="small">全部展开</el-button>
        </div>
        <div class="button-container"
             v-if="depth === 5"
             style="margin-right:18px"
             @click="collapse">
          <img src="../assets/icon-collapse.svg"
               alt="">
          <el-button type="text"
                     size="small">全部折叠</el-button>
        </div>
        <div class="button-container"
             @click="res = null">
          <img src="../assets/icon-close.svg"
               alt="">
          <el-button type="text"
                     size="small">关闭</el-button>
        </div>
      </div>
      <div class="url">{{ showUrl }}</div>
      <div>
        <vue-json-pretty v-if="res"
                         :data="res"
                         class="json-container"
                         :deep="depth"> </vue-json-pretty>
      </div>
    </div>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  components: {
    VueJsonPretty
  },
  data() {
    return {
      params: {
        key: 'lbs-meituan-demo',
        polygon: '',
        keywords: '',
        location: '',
        page: 1,
        pagesize: 20
      },
      baseUrl: 'https://lbsapi.meituan.com/v1/search/polygon',
      url: '',
      res: null,
      showUrl: '',
      expanded: true,
      depth: 1
    };
  },
  methods: {
    run() {
      //
      const baseUrl = this.baseUrl;
      const params = this.params;
      this.url = `${baseUrl}?${this.$qs.stringify(params)}`;
      this.$http.get(this.url).then((res) => {
        this.res = res.data;
      });
      this.showUrl = this.url.replace('lbs-meituan-demo', '您的key');
      // //
    },
    expand() {
      const res = this.res;
      this.depth = 5;
      this.res = null;
      this.$nextTick(() => {
        this.res = res;
      });
    },
    collapse() {
      const res = this.res;
      this.depth = 1;
      this.res = null;
      this.$nextTick(() => {
        this.res = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import '../document.less';
</style>
